var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "ticket-filter-toolbar" },
    [
      _c(
        "CommonFilterTool",
        {
          attrs: {
            "keep-state-on-query-params": false,
            "filter-meta": _vm.filterMetas,
            "label-formatter": _vm.filterLabelFormatter,
            showClearAll: false && _vm.isClearAllEnabled(),
            "filter-templates": _vm.getFilterTemplates(),
            "selected-filter-template": _vm.getSelectedFilterTemplateName(),
            "hide-filters":
              false && this.selectedCustomFilterTemplate !== "custom",
            "show-add-button": true,
            "required-filters": _vm.getRequiredBreakdowns(),
          },
          on: {
            addFilter: _vm.addFilter,
            applyFilterTemplate: _vm.applyFilterTemplate,
          },
          model: {
            value: _vm.ticketFilter,
            callback: function ($$v) {
              _vm.ticketFilter = $$v
            },
            expression: "ticketFilter",
          },
        },
        [_c("template", { slot: "extra" }, [_vm._t("extra")], 2)],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }